import { useTranslation } from "react-i18next";
import { useLaboratoryProtocolInventory } from "../Hooks/useLaboratoryProtocolInventory";
import React, { useEffect, useState } from "react";
import { CustomSelect } from "../../../components/CustomControls/CustomSelect";
import { Col, ControlLabel, FormGroup, Row } from "react-bootstrap";
import { Remove } from "../../../components/Icons/Icons";
import { Tooltip } from "../../../components/Utils/Tooltips";

export default function InventoryProtocolFilter({ onSelectedProtocol, disabled = false }) {
    const { t } = useTranslation();
    const [protocolState, handleLaboratoryChange, getProtocolById] = useLaboratoryProtocolInventory();
    const [selectedLaboratory, setSelectedLaboratory] = useState(null)
    const [selectedProtocol, setSelectedProtocol] = useState(null)

    useEffect(() => {
        if (selectedLaboratory === null) return
        handleLaboratoryChange(selectedLaboratory.Value)
    }, [selectedLaboratory])

    useEffect(() => {
        if (selectedProtocol === null) return
        onSelectedProtocol(selectedProtocol.Value)
    }, [selectedProtocol])

    const clearProtocolLaboratory = () => {
        setSelectedLaboratory(null)
        setSelectedProtocol(null)
    }

    return (<Row style={{ width: '100%', marginBottom: '1rem' }}>
        <Col sm={11} md={5}>
            <FormGroup>
                <ControlLabel>{t('commons.laboratories')}</ControlLabel>
                <CustomSelect
                    name={`select_laboratory`}
                    value={selectedLaboratory}
                    onChange={(e, v) => { setSelectedLaboratory(v) }}
                    options={protocolState.laboratories}
                    getOptionLabel={(option) => option?.Name}
                    getOptionValue={(option) => option?.Value}
                    isDisabled={selectedProtocol != null}
                    placeholder={t('commons.select')}
                />
            </FormGroup>
        </Col>
        <Col sm={11} md={5}>
            <FormGroup>
                <ControlLabel>{t('commons.protocols')}</ControlLabel>
                <CustomSelect
                    name={`protocol_select`}
                    value={selectedProtocol}
                    onChange={(e, v) => {
                        setSelectedProtocol(v)
                    }}
                    options={protocolState.protocols}
                    getOptionLabel={(option) => option?.Name}
                    getOptionValue={(option) => option?.Value}
                    isDisabled={(selectedLaboratory === null || !(protocolState.protocols.length > 0))}
                    placeholder={t('commons.select')}
                />
            </FormGroup>
        </Col>
        <Col sm={2}>
            <div style={{ paddingTop: '2.5rem' }}>
                <button className="btn btn-danger" disabled={disabled || !selectedProtocol} onClick={clearProtocolLaboratory}>
                    <Tooltip tooltip={t('commons.clear')} id={"tooltipedit-limpiaseleccion"}>
                        <span aria-hidden="true"><Remove /></span>
                    </Tooltip>
                </button>
            </div>
        </Col>
    </Row>)
}